import { makeAutoObservable, runInAction } from 'mobx';
import { Match } from 'navigo';

import { JobSummaryOutput } from 'dtos/jobs/JobSummaryOutput';
import { serverUri } from 'utils/config';
import { nullsToUndefined } from 'utils/nullsToUndefined';
import { AuthStore } from 'stores/users/AuthStore';

export class JobsListStore {
  jobs?: JobSummaryOutput[];

  constructor(private readonly authStore: AuthStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  activate(match: Match) {
    this.jobs = undefined;
    this.getJobs();
  }

  async ensureJobsLoaded() {
    if (this.jobs === undefined) {
      await this.getJobs();
    }
  }
  async getJobs() {
    try {
      const response = await this.authStore.fetchWithAuth(`${serverUri}/jobs`, {
        method: 'GET',
      });
      if (!response.ok) throw new Error('Error getting jobs');
      const output: JobSummaryOutput[] = nullsToUndefined(await response.json());

      runInAction(() => {
        this.jobs = output;
      });
    } catch (err) {
      console.error(err);
      runInAction(() => {
        this.jobs = undefined;
      });
    }
  }
}
